//@ts-check
/// <reference path="./table-sorter.d.ts" />
/// <reference path="@types/global.d.ts" />

import {TableSorter} from './table-sorter';

'use strict';

/**
 * @typedef {import("./table-sorter").TableSorterSettings} TableSorterSettings
 */

document.addEventListener('DOMContentLoaded', async function() {
	/** @type {TableSorter[]} */
	const sorters = [];
	
	/** @type {Partial<TableSorterSettings>} */
	const options = {
		// Performs better with numbers, when nothing is set
		defaultSortType: TableSorter.SORT_TYPE_NATURAL,
		
		operations: [
			TableSorter.SORT_ASC,
			TableSorter.SORT_DESC
		],
		
		button: {
			tag: 'button',
			title: {
				[TableSorter.SORT_ASC]: 'Ascending',
				[TableSorter.SORT_DESC]: 'Descending',
				[TableSorter.SORT_NONE]: 'Click to sort',
				...TVK_SCRIPTS.TableSorter.title,
			},
			icon: {
				tag: 'span',
				baseClass: 'has-icon',
				[TableSorter.SORT_ASC]: 'has-icon-sort-asc',
				[TableSorter.SORT_DESC]: 'has-icon-sort-desc',
				[TableSorter.SORT_NONE]: 'has-icon-sort-none'
			}
		}
	};
	
	
	//#region Handle simple odds tables
	{
		const tables = document.querySelectorAll('table.odds-table');
		
		for(const table of tables) {
			if(!(table instanceof HTMLTableElement)) {
				continue;
			}
			
			let column = table.querySelector('tr:first-child > th:nth-child(2)');
			
			if(!column || !(column instanceof HTMLTableCellElement)) {
				continue;
			}
			
			
			try {
				const sorter = new TableSorter(table, {
					...options,
					
					columns: [column],
					
					autoSort: {
						column: column,
						direction: TableSorter.SORT_ASC,
					},
				});
				
				sorters.push(sorter);
			} catch(e) {
				console.error(e);
			}
		}
	}
	//#endregion
	
	
	
	//#region Handle complicated odds tables
	{
		const tables = document.querySelectorAll('table.tg');
		
		for(const table of tables) {
			if(!(table instanceof HTMLTableElement)) {
				continue;
			}
			
			
			/** @type {NodeListOf<HTMLTableCellElement>} */
			let columns = table.querySelectorAll('tr:first-child > th:first-child ~ th');
			
			if(!columns.length) {
				continue;
			}
			
			try {
				const sorter = new TableSorter(table, {
					...options,
					
					columns: columns,
					
					autoSort: {
						column: columns[1] ?? columns[0] ?? 0,
						direction: TableSorter.SORT_ASC,
					},
				});
				
				sorters.push(sorter);
			} catch(e) {
				console.error(e);
			}
		}
	}
	//#endregion
	
	
	
	//#region Handle block odds tables
	{
		const tables = document.querySelectorAll('table.odds-table-simple__sortable');
		
		for(const table of tables) {
			if(!(table instanceof HTMLTableElement)) {
				continue;
			}
			
			
			/** @type {NodeListOf<HTMLTableCellElement>} */
			let columns = table.querySelectorAll('thead > tr:first-child > th[data-sort]');
			
			if(!columns.length) {
				continue;
			}
			
			try {
				/** @type {Partial<TableSorterSettings>} */
				let table_options = {
					...options,
					
					columns: columns,
				};
				
				
				// We need to find if there's a column indicating the table is already sorted
				
				/** @type {HTMLTableCellElement|null} */
				let sort_column = Array.from(columns)
					.filter((cell) => cell.getAttribute(TableSorter.SORTED_ATTR) === TableSorter.SORT_ASC
						|| cell.getAttribute(TableSorter.SORTED_ATTR) === TableSorter.SORT_DESC
					)[0] ?? null;
				
				if(sort_column) {
					/** @type {string|null} */
					let sort_column_dir = sort_column.getAttribute(TableSorter.SORTED_ATTR);
					
					// If it is sorted, we just have to make the class see it via `autoSort`
					if(
						sort_column_dir === TableSorter.SORT_ASC
						|| sort_column_dir === TableSorter.SORT_DESC
					) {
						table_options.autoSort = {
							column: sort_column,
							direction: sort_column_dir,
						};
					}
					
					sort_column = null;
				}
				
				
				const sorter = new TableSorter(table, table_options);
				
				sorters.push(sorter);
			} catch(e) {
				console.error(e);
			}
		}
	}
	//#endregion
});
